import { render, staticRenderFns } from "./WDropdownItem.vue?vue&type=template&id=2d54e44b&"
import script from "./WDropdownItem.vue?vue&type=script&lang=ts&"
export * from "./WDropdownItem.vue?vue&type=script&lang=ts&"
import style0 from "./WDropdownItem.vue?vue&type=style&index=0&id=2d54e44b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports